import { Button } from '@repo/ui';
import { Calculator } from 'lucide-react';
import { type ReactElement, useState } from 'react';
import { useKeyboardShortcut } from '@/hooks/useKeyboardShortcut';
import { useAuthStore } from '@/stores/auth.store';
import { CalculatorModal } from './CalculatorModal';

/**
 * CalculatorButton — TopBar entry point for the standalone quote
 * calculator (Slice 8 PR#1).
 *
 * Owns the modal open state and wires the global ⌘K shortcut (which
 * matches the hint already shown in the TopBar search box). Rendered
 * only for authenticated users; it is intentionally NOT wrapped in a
 * PermissionGate — every role may open the calculator (CALC-1). The
 * role gates the OUTPUTS (margin/commission), not access.
 *
 * The UI package has no Tooltip primitive, so the affordance uses a
 * native `title` attribute.
 */
export function CalculatorButton(): ReactElement | null {
  const user = useAuthStore((s) => s.user);
  const [open, setOpen] = useState(false);

  useKeyboardShortcut('mod+k', () => setOpen(true), Boolean(user));

  if (!user) return null;

  return (
    <>
      <Button
        type="button"
        variant="ghost"
        size="icon"
        onClick={() => setOpen(true)}
        aria-label="Calculadora"
        title="Calculadora (⌘K)"
      >
        <Calculator className="size-4" aria-hidden="true" />
      </Button>
      <CalculatorModal open={open} onOpenChange={setOpen} />
    </>
  );
}
